import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Form, Table } from 'react-bootstrap';
import { Cache } from 'aws-amplify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { deleteProjectMember, 
  updateMembers, 
  computeMemberBandCost, 
  addProjectMember, 
  resetProjectMembers, 
  fetchProjectMembers, 
  updateMemberHours } from '../../store/actions/projects/projectMembersActions';
import { toggleDialogBox, clearSelectedUserOpt, toggleShowAlert, resetIsSaving, ERROR_ALERT } from '../../store/actions/commonActions';
import { toMonetaryFormat } from '../../common/Utilities';
import Avatar from 'react-avatar';
import ProgressingButton from '../../common/ProgressingButton';
import { FINANCE_APPROVER, 
  PORTAL_ADMIN, 
  MANAGER,
  PROJECT_ADMIN, 
  PROJECT_SPONSOR,
  TEAM_LEADER } from '../../store/actions/users/usersActions';
import SelectUserField from '../../common/SelectUserField';
import { fetchUsers, setUser } from '../../store/actions/users/usersActions';
import { PENDING } from '../../store/actions/projects/projectsActions';

class ProjectMembers extends Component {

  constructor(props) {
    super(props);
    this.saveHoursButton = "Save";
    this.mandays = 0;
    this.manhours = 0;
    this.projectCost = 0;
    this.overBudget = false;
    this.disableBtn = true;
    this.roleId = '';

    this.allowedRoles = [
      PROJECT_ADMIN, 
      MANAGER,
      PROJECT_SPONSOR, 
      FINANCE_APPROVER, 
      PORTAL_ADMIN,
      TEAM_LEADER
    ];
  }

  componentDidMount() {
    this.roleId = Cache.getItem('roleId');

    this.props.fetchUsers({is_disabled: 0});
    this.props.resetIsSaving();
  }

  displayManageMemberBtn = () => {
    if (this.props.isManageable || this.props.readOnly) {
      return '';
    }

    return (
      <div className="float-right">
        <Button size="sm" onClick={() => {
          this.props.toggleDialogBox(true);
        }}>Manage Members</Button>
      </div>
    )
  }
  
  displayRemoveButton = (projectMemberId) => {
    if (this.props.isManageable) {
      return (
        <td>
          <Button variant="default" size="sm" onClick={() => {
            this.props.deleteProjectMember(projectMemberId);
          }}>
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </td>
      )
    }
  }

  displayBudgetHoursTH = () => {
    if (!this.props.isManageable) {
      return (
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          Budgeted Hours
        </Col>
      )
    }
  }

  calculateManhours = (e, memberId) => {
    let memberHours = parseFloat(e.target.value);

    if (!memberHours) {
      memberHours = 0;
    }

    this.props.updateMemberHours(memberHours, memberId);
  } 

  displayMemberHours = (memberBudgetedHours, projectMemberId) => {

    if (!this.props.isManageable) {
      let displayEnterHours = false;
      if (this.props.readOnly || !this.allowedRoles.includes(this.roleId)) {
        displayEnterHours = true;
      }

      return (
        <Form.Control 
          size="sm" 
          disabled={displayEnterHours}
          className="budgetedHours" 
          step="0.01" 
          type="number" 
          placeholder="Enter hours" 
          defaultValue={memberBudgetedHours} 
          onBlur={(e) => {
            this.disableBtn = false;
            this.calculateManhours(e, projectMemberId);
          }}
          min="0"
        />
      )
    }
  }

  displayPartialManhours = () => {
    const project = this.props.projects.project;
    const projectMembers = this.props.projects.projectMembers;

    let hoursIndicator = '';
    let costIndicator = '';

    if (!projectMembers || !projectMembers.length) {
      return '';
    }

    let partialManhours = 0;
    let partialCost = 0;

    if (Object.keys(project).length) {
      partialManhours = project.partial_budgeted_hours;
      partialCost = project.partial_cost;
      if (partialManhours > project.budgeted_hours) {
        hoursIndicator = "over-budget";
      }

      if (partialCost > project.fully_loaded_cost) {
        costIndicator = "over-budget";
        this.overBudget = true;
      }
      else {
        this.overBudget = false;
      }
    }

    let totalCostData = '';
    let rowColSpan = '';
    if (this.allowedRoles.includes(this.roleId)) {
      rowColSpan = 3;
      totalCostData = (
        <td>
          <b className="float-left">
            Total Budget Cost: <span className={costIndicator}>
              {partialCost > 0 ? toMonetaryFormat(partialCost) : "0.00"}
            </span>
          </b>
        </td>
      )
    }
    else {
      rowColSpan = 2;
    }

    return (
      <tr>
        <td colSpan={rowColSpan}>
        </td>
        <td>
          <b className="float-left">Total Budgeted Hours: <span className={hoursIndicator}>{partialManhours}</span></b>
        </td>
        {totalCostData}
      </tr>
    )
  }

  renderProjectMembers = () => {
    const projectMembers = this.props.projects.projectMembers;
    
    let projectMembersList = '';

    let iconColSize = 1;
    let nameColSize = 5;
    let btnColSize = 6;
    let itemView = '';

    if (this.props.isManageable) {
      iconColSize = 2;
      nameColSize = 8;
      btnColSize = 2;
    }

    let tableColSpan = '';

    if (this.allowedRoles.includes(this.roleId)) {
      tableColSpan = 5;
    }
    else {
      tableColSpan = 3;
    }

    if (projectMembers) {
      projectMembersList = projectMembers.length > 0 ? (
        projectMembers.map((projectMember, key) => {
          let projectMemberId = '';
          let userId = 0;
          let lastName = '';
          let firstName = '';
          let fullName = '';
          let email = '';
          let memberbudgetedHours = 0;
          let memberBandCost = 0;
          let band = '';

          if (typeof(projectMember.user) != "undefined") {
            const user = projectMember.user;

            if (user) {
              projectMemberId = projectMember.id;
              userId = user.id;
              lastName = user.last_name;
              firstName = user.first_name;
              email = user.email;
              fullName = firstName + " " + lastName;

              if (typeof(user.band) !== "undefined" && user.band) {
                band = user.band ? "Band " + user.band.band_name : "";
              }
            }
            
            memberbudgetedHours = projectMember.user_budgeted_hours;

            if (typeof(projectMember.member_band_cost) !== "undefined" && projectMember.member_band_cost) {
              memberBandCost = projectMember.member_band_cost;
            }
          }

          if (!this.props.isManageable) {

            let bandTableData = '';
            let costTableData = '';

            if (this.allowedRoles.includes(this.roleId)) {
              bandTableData = (
                <td>
                  {band}
                </td>
              )

              costTableData = (
                <td>
                  { memberBandCost > 0 ? toMonetaryFormat(memberBandCost) : "" }
                </td>
              )
            }

            itemView = (
              <tr key={key}>
                <td>
                  <Avatar name={fullName} size="40" round={true} />
                </td>
                <td>
                  {firstName} {lastName}
                  <div className="small text-muted">{email}</div>
                </td>
                {bandTableData}
                <td>
                  { this.displayRemoveButton(projectMemberId) } 
                  { this.displayMemberHours(memberbudgetedHours, projectMemberId)}
                </td>
                {costTableData}
                {[PROJECT_SPONSOR, MANAGER, PORTAL_ADMIN, TEAM_LEADER].includes(this.roleId) && !this.props.readOnly && <td>
                  <Button className="btn-icon" onClick={() => {
                    this.props.deleteProjectMember(projectMemberId);
                  }}>
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </td>}
              </tr>
            )
          }
          else {
            itemView = (
              <Row key={key} className="mt-3 mr-3">
                <Col xs={iconColSize} sm={iconColSize} md={iconColSize} lg={iconColSize} xl={iconColSize}>
                  <Avatar name={fullName} size="40" round={true} />
                </Col>
                <Col xs={nameColSize} sm={nameColSize} md={nameColSize} lg={nameColSize} xl={nameColSize}>
                  {firstName} {lastName}
                  <div>
                    <span className="small text-muted">{email}</span>
                  </div>
                </Col>
                <Col xs={btnColSize} sm={btnColSize} md={btnColSize} lg={btnColSize} xl={btnColSize}>
                  { this.displayRemoveButton(projectMemberId) } 
                  { this.displayMemberHours(memberbudgetedHours, userId)}
                </Col>
              </Row>
            )
          }

          return itemView
        })
      ) : (
        <tr>
          <td colSpan={tableColSpan}>Loading...</td>
        </tr>
      )
    }
    else {
      projectMembersList = (
        <tr>
          <td colSpan={tableColSpan}>No project members found.</td>
        </tr>
      )
    }

    return projectMembersList;
  }

  displaySaveHoursBtn = () => {
    const projectMembers = this.props.projects.projectMembers;
    if (this.props.isManageable || this.props.readOnly || !projectMembers) {
      return '';
    }

    if (this.overBudget) {
      this.disableBtn = true; 
    }

    return (
      <Row className="mt-5">
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="float-right">
            <Button 
              className="mr-3"
              variant="default" 
              type="submit" 
              onClick={(e)=>{
                this.props.resetProjectMembers();
                this.props.fetchProjectMembers();
                this.props.history.push('/projects/view?id=' + this.props.project.id);
            }}>Cancel</Button>
            <ProgressingButton 
              id="saveHoursButton" 
              variant="primary" 
              type="submit" 
              disabled={this.disableBtn}
              buttonValue={this.saveHoursButton}
              onClick={()=>{
                this.props.updateMembers();
              }} />
          </div>
          
        </Col>
      </Row>
    )
  }

  displayProjectCostings = () => {
    if (this.props.isManageable) {
      return '';
    }
    const project = this.props.projects.project;

    if (Object.keys(project).length) {
      this.mandays = project.mandays;
      this.manhours = project.budgeted_hours;
      this.projectCost = +project.fully_loaded_cost;
      this.isFullyLoaded = +project.fully_loaded
    }

    return (
      <>
        <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3}>
            <b>Project Mandays</b>
          </Col>
          <Col>
            {this.mandays.toFixed(2)}
          </Col>
        </Row>
        <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3}>
            <b>Project Budgeted Hours</b>
          </Col>
          <Col>
            {this.manhours.toFixed(2)}
          </Col>
        </Row>
        {[PROJECT_SPONSOR, MANAGER, PORTAL_ADMIN, TEAM_LEADER].includes(this.roleId) && <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3}>
            <b>{this.isFullyLoaded ? 'Fully Loaded' : 'Unloaded'} Cost</b>
          </Col>
          <Col>
            {this.projectCost && this.projectCost > 0 ? toMonetaryFormat(this.projectCost) : "0.00"}
          </Col>
        </Row> }
      </>
    )
  }

  displayMembersGrid = () => {
    if (!this.props.isManageable) {

      let bandTableHeader = '';
      let costTableHeader = '';

      if (this.allowedRoles.includes(this.roleId)) {
        bandTableHeader = (
          <th width="20%">Band</th>
        )

        costTableHeader = (
          <th className="align-center" width="20%">Cost</th>
        )
      }

      return (
        <Table>
          <thead>
            <tr>
              <th width="5%"></th>
              <th className="align-center" width="35%">Member</th>
              {bandTableHeader}
              <th className="align-center" width="15%">Budgeted Hours</th>
              {costTableHeader}
              {[PROJECT_SPONSOR,PORTAL_ADMIN].includes(this.roleId) && !this.props.readOnly && <th width="5%"></th>}
            </tr>
          </thead>
          <tbody>
            { this.renderProjectMembers() }
            { this.displayPartialManhours() }
          </tbody>
        </Table>
      )
    }
    else {
      return(
        <>
          { this.renderProjectMembers() }
        </>
      )
    }
  }

  displaySelectUser = () => {
    const project = this.props.project;
  
    if (this.props.readOnly) {
      return '';
    }

    if (!this.allowedRoles.includes(this.roleId)) {
      return '';
    }

    let users = this.props.users.users;
    let projectMembers = this.props.projects.projectMembers;
    let arrProjectMembers = [];

    if (projectMembers) {
      if (projectMembers.length) {
        projectMembers.forEach(projectMember => {
          arrProjectMembers.push(projectMember.user.id);
        })
      }
    }
    
    //filter users
    users = users.filter(user => {
      if (!arrProjectMembers.includes(user.id) && user.group && user.group.id && project.platform.includes(+user.group.id)) {
        return user;
      }
      return false;
    }).map(user => {
      return user;
    })

    const onChangeCallback = (value) => {
      if (value) {
        users.filter(data => {
          if (data.id === value.value) {
            return data;
          }
          return null;
        }).forEach(user => {
          this.props.setUser(user);
          Object.assign(user, {approver_id: user.id});
          this.props.addProjectMember(user);
          this.props.clearSelectedUserOpt();
        })
      }
    }

    return (
      <>
        <Row>
          <Col>
            <h6>Add Member</h6>
          </Col>
        </Row>
        <Row>
          <Col>
            <SelectUserField 
              users={users} 
              selectOnce={true} 
              multiple={false} 
              fieldName="select_user" 
              onChangeCallback={onChangeCallback} 
            />
          </Col>
          <Col>
          </Col>
        </Row>
      </>
    )
  }

  render() {
    const project = this.props.projects.project;
    this.roleId = Cache.getItem('roleId');

    if (!this.props.readOnly && project.is_disabled) {
      this.props.toggleShowAlert(true, ERROR_ALERT, "You are not allowed to perform this action.");
      this.props.history.push('/projects/disabled');
    }

    if (!this.props.readOnly && (project.status === PENDING && 
      (this.roleId !== PORTAL_ADMIN && this.roleId !== PROJECT_ADMIN))) {
      this.props.toggleShowAlert(true, ERROR_ALERT, "You are not allowed to perform this action. Project is still pending for approval");
      this.props.history.push('/projects/view?id='+project.id);
    }

    if (!this.props.readOnly && project.is_disabled) {

    }

    return ( 
      <>
        <Row className={this.props.isManageable ? "mt-3" : ""}>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Team Members</h6>
          </Col>
        </Row> 
        <hr />
        <Row className="mt-3">
          <Col>
            { this.displayProjectCostings() }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            { this.displaySelectUser() }
          </Col>
        </Row>
        { this.displayMembersGrid() }
        
        { this.displaySaveHoursBtn() }
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  users: state.users 
})

const mapDispatchToProps = (dispatch) => {
  return {
    deleteProjectMember: (...args) => dispatch(deleteProjectMember(...args)),
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),
    updateMembers: (...args) => dispatch(updateMembers(...args)),
    updateMemberHours: (...args) => dispatch(updateMemberHours(...args)),
    computeMemberBandCost: (...args) => dispatch(computeMemberBandCost(...args)),
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
    setUser: (...args) => dispatch(setUser(...args)),
    addProjectMember: (...args) => dispatch(addProjectMember(...args)),
    clearSelectedUserOpt: (...args) => dispatch(clearSelectedUserOpt(...args)),
    fetchProjectMembers: () => dispatch(fetchProjectMembers()),
    resetProjectMembers: () => dispatch(resetProjectMembers()),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    resetIsSaving: () => dispatch(resetIsSaving())
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectMembers))
